import React, { useState, useEffect } from "react";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import "./File.css";

import AnswerComments from "../AnswerComments/AnswerComments";

const FileResult = ({ result, header, status }) => {
  const [currentFilenames, setCurrentFilenames] = useState([]);
  const [currentFileLinks, setCurrentFileLinks] = useState([]);
  const [resultFilenames, setResultFilenames] = useState([]);
  const [resultFileLinks, setResultFileLinks] = useState([]);
  const [showPopUp, setShowPopup] = useState(false);

  useEffect(() => {
    if (result) {
      if (typeof result.answers === "string") {
        console.log(result.answers);
        setCurrentFileLinks([result.answers]);
        setResultFileLinks([result.files]);
      } else if (Array.isArray(result.answers)) {
        console.log(result.answers);
        setCurrentFilenames(result.answers.map((a) => a.filename));
        setCurrentFileLinks(result.answers.map((a) => a.file_url));
      } else if (
        typeof result.answers === "object" &&
        result.answers !== null
      ) {
        if (Array.isArray(result.answers.file_address)) {
          console.log(result.answers.file_address);
          setCurrentFilenames(
            result.answers.file_address.map((a) => a.filename)
          );
        } else if (result.answers.third_party_url !== null) {
          setCurrentFileLinks(result.answers.third_party_url);
        }
      }
      console.log(result);
      if (Array.isArray(result.result_files)) {
        setResultFilenames(result.result_files.map((f) => f.filename));
        setResultFileLinks(result.result_files.map((f) => f.third_party_url));
      }
    }
  }, [result]);

  function handlePopUp() {
    setShowPopup(!showPopUp);
  }

  const getDisplayFilename = (filename, maxLength = 15) => {
    const ext = filename.split(".").pop();
    const name = filename.slice(0, filename.lastIndexOf("."));

    if (name.length <= maxLength) {
      return filename;
    }

    return `${name.slice(0, maxLength)}... .${ext}`;
  };

  console.log(result);
  console.log(currentFilenames, resultFileLinks, resultFileLinks);
  console.log(result?.result_third_party_url, resultFileLinks);
  return (
    <div className="fileResult__container">
      <div>
        {(result.answers?.third_party_url ||
          (resultFileLinks && resultFileLinks.length !== 0)) && (
          <div className="fileResult__inputResult">
            <div>
              {result.answers?.third_party_url
                ? result.answers?.third_party_url
                : resultFileLinks}
            </div>
          </div>
        )}
        {result.is_correct >= 0 && (
          <>
            <div className="fileResult__answerPoint_wrap"></div>
            <div className="fileResult__answerPoint">
              <span
                style={{
                  color:
                    result.is_correct >= 70
                      ? "#22C532"
                      : result.is_correct >= 50
                      ? "#f6c71e"
                      : "#FF0000",
                }}
              >
                {result.is_correct}
              </span>
              баллов
            </div>
          </>
        )}
        {currentFilenames.length > 0 && (
          <div className="file__previewsResult">
            {currentFilenames.map((filename, index) => (
              <div className="file__previewContainerResult" key={index}>
                <Link to={currentFileLinks[index]} className="file__preview">
                  {index + 1}. {getDisplayFilename(filename)}
                </Link>
              </div>
            ))}
          </div>
        )}
        {resultFilenames.length > 0 && (
          <div className="file__previewsResult">
            {resultFilenames.map((filename, index) => (
              <div className="file__previewContainerResult" key={index}>
                <Link to={resultFileLinks[index]} className="file__preview">
                  {index + 1}. {getDisplayFilename(filename)}
                </Link>
              </div>
            ))}
          </div>
        )}

        {/*Oтображается в результатах теста или сразу после ответа в упражнениях, до тех пор, пока не пришли баллы-оценка от учителя */}
        {(status === null || result.is_correct === null) && (
          <div className="openQuestion__announcement_wrap fileResult">
            <div className="openQuestion__announcement">
              <p>Ваш ответ отправлен преподавателю на проверку.</p>
              <p>
                После того, как работа будет проверена, Вы получите уведомление
                в личном кабинете и сможете посмотреть результаты.
              </p>
            </div>
          </div>
        )}
        {/*Oтображается при просмотре результатов, если от учителя пришли комментарии или ссылки на файлы или сами файлы*/}
        {(result?.result_comment ||
          result?.result_third_party_url ||
          result?.result_files) && (
          <div className="comment-box" onClick={handlePopUp}>
            Комментарий
            {showPopUp && (
              <AnswerComments
                result={result}
                header={header}
                resultFilenames={resultFilenames}
                currentFilenames={currentFilenames}
                resultFileLinks={resultFileLinks}
                currentFileLinks={currentFileLinks}
                handlePopUp={handlePopUp}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FileResult;
